module.exports = __webpack_public_path__ + "img/dataCenter_pic.b0163c8a.png";